// extracted by mini-css-extract-plugin
export default {"wrap":"NH-z","articleImagesWrap":"OH-z","articleImage":"PH-z","singleImage":"QH-z"};